var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { fromSize } from '../../utilities/media';
export var Backdrop = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: ", ";\n\n  ", " {\n    padding: ", ";\n\n    ", "\n  }\n"], ["\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  background: ", ";\n\n  ", " {\n    padding: ", ";\n\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme,
    hideBackdrop = _a.hideBackdrop;
  return hideBackdrop ? 'none;' : "".concat(theme.tokens.interface.neutral.strong, "cc");
}, fromSize('md'), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.xl;
}, function (_a) {
  var containerPosition = _a.containerPosition;
  switch (containerPosition) {
    case 'center':
      return "\n            align-items: center;\n            justify-content: center;\n          ";
    case 'top':
      return 'align-items: flex-start;';
    case 'right':
      return 'justify-content: flex-end;';
    case 'bottom':
      return 'align-items: flex-end;';
    case 'left':
      return 'justify-content: flex-start;';
    case 'topRight':
      return "\n            align-items: flex-start;\n            justify-content: flex-end;\n          ";
    case 'bottomRight':
      return "\n            align-items: flex-end;\n            justify-content: flex-end;\n          ";
    case 'bottomLeft':
      return "\n            align-items: flex-end;\n            justify-content: flex-start;\n          ";
    case 'topLeft':
      return "\n            align-items: flex-start;\n            justify-content: flex-start;\n          ";
    default:
      return "\n            align-items: center;\n            justify-content: center;\n          ";
  }
});
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  justify-content: center;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  ", " {\n    margin-left: 0;\n    margin-right: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  justify-content: center;\n  margin-left: ", ";\n  margin-right: ", ";\n\n  ", " {\n    margin-left: 0;\n    margin-right: 0;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.lg;
}, function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.lg;
}, fromSize('md'));
var templateObject_1, templateObject_2;